import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import CloseIcon from "@mui/icons-material/Close";

// Components
import WmsItemInformation from "components/WMS/Mobile/WmsItemInformation/WmsItemInformation";
import RightDrawer from "components/WMS/Mobile/RightDrawer";

WmsItemInformationDrawer.propTypes = {
    handleClose: PropTypes.func.isRequired,
    selectedWmsItem: PropTypes.object,
};

function WmsItemInformationDrawer({selectedWmsItem = null, handleClose, ...props}) {
    if (!selectedWmsItem) {
        return null;
    }

    return (
        <RightDrawer
            open={!!selectedWmsItem}
            handleClose={handleClose}
            headerCenterContent={(
                <b><FormattedMessage id='wms.myPickingMissions.popup.product.title' /></b>
            )}
            headerRightContent={(
                <CloseIcon onClick={handleClose} />
            )}
        >
            <WmsItemInformation wmsItem={selectedWmsItem}>
                {props.children}
            </WmsItemInformation>
        </RightDrawer>
    );
}

export default WmsItemInformationDrawer;
